import Col from "../../common/DataTableV2/Col";
import { DataTableV2 } from "../../common/DataTableV2";
import classNames from "classnames";
import React, { PropTypes } from "react";
import { FormattedDate, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router";
import { getLocalStorageFilter, setLocalStorageFilters } from "../../common/LocalStorageFilters/LocalStorageFilters";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";
import { canDownload } from "../../common/CanDownload";
import { EN, FR } from "../../common/enums/languages";
import { EQUALS, LIKE } from "../../common/GraphQL/GraphQLFilterTypes";
import { getParsedErrors, getSingleErrorFromCode, renderErrorModal } from "../../common/form/FieldErrorHelper";
import {
    buildGraphQLQueryParams,
    formatMultipleFilters,
    toGraphQLFormat,
    toGraphQLSortFormat,
} from "../../common/GraphQL/GraphQLQueryHelper";
import enCA from "../../intl/en-CA";
import frCA from "../../intl/fr-CA";

import { pipe } from "ramda";
import { toast } from "react-toastify";
import { updateCurrentURL, getQueryParams, getUrlParam } from "../../../../utils/url";
import store from "../../../store";
import {
    ADMINISTRATOR,
    DIRECTOR,
    FINANCE,
    FINTECH,
    HIGH_MANAGEMENT_WITH_FINANCE,
    INTERNAL_ROLES,
    MANAGER,
    PLAN_ADMINISTRATOR,
} from "../../../utils/Roles";
import * as types from "../../../utils/data/dataActionTypes";
import * as dataActions from "../../../utils/data/dataActions";
import { CLIENT_CONFIGURATION, CLIENTS, CLIENTS_TABLE_GRAPHQL, CLIENTS_V2 } from "../../../utils/data/models";
import userHasAccess from "../../../utils/userHasAccess";
import { ArchiveButton, CheckboxButton, DownloadButton, EditButton, OptionsMenu } from "../../common";
import BasicClientsFields from "./client-form/BasicClientFields";
import { cleanBrokerRelationshipsFromForm } from "./client-form/basic-client-sections/associatedBrokers";
import { updateClientAndValidate } from "./client/clientActions";
import { AUTOMATIC } from "./enums/automaticMemberIdentifierOptions";
import { MANUAL as MANUAL_BILLING_PERIOD, RECURRING } from "./enums/billingPeriodTypes";
import { GM, PM } from "./enums/businessAccountTypes";
import _ from "lodash";
import clientStatusTypes, {
    ACTIVE,
    IMPLEMENTATION,
    INACTIVE,
    RESTRICTED_STATUSES,
    TERMINATED,
} from "./enums/clientStatusTypes";
import clientTypes from "./enums/clientTypes";
import insuranceStatuses from "./enums/insuranceStatuses";
import ratePeriodTypes from "./enums/ratePeriodTypes";

const localStorageKeyDict = {
    clientTypeFilter: "clientTypeFilter",
    clientBlocFilter: "clientBlocFilter",
    clientFilter: "clientFilter",
    clientNumFilter: "clientNumFilter",
    clientEDateFilter: "clientEDateFilter",
    clientRDateFilter: "clientRDateFilter",
    clientUserFilter: "clientUserFilter",
    clientStatusFilter: "clientStatusFilter",
    clientCheckboxFilter: "clientCheckboxFilter",
    clientArchiveFilter: "clientArchiveFilter",
    serviceRepresentativeFilter: "serviceRepresentativeFilter",
};

const urlKeyDict = {
    clientTypeFilter: "clientTypeName",
    clientBlocFilter: "blocName",
    clientFilter: "name",
    clientNumFilter: "clientNumber",
    clientEDateFilter: "calculatedEffectiveDate",
    clientRDateFilter: "calculatedRenewalDate",
    clientUserFilter: "accountManagerFullName",
    clientStatusFilter: "clientStatusType",
    clientCheckboxFilter: "clientCheckbox",
    clientArchiveFilter: "clientArchive",
    serviceRepresentativeFilter: "serviceRepresentativeFullName",
};

let filtrableColsInitState = {
    selectedClientTypes: {
        col: "clientTypeName",
        key: "clientTypeNameVal",
        urlKey: urlKeyDict.clientTypeFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: clientTypes
    },
    selectedBlocs: {
        col: "blocName",
        key: "blocName",
        urlKey: urlKeyDict.clientBlocFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
    },
    selectedClients: {
        col: "name",
        key: "nameVal",
        urlKey: urlKeyDict.clientFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: []
    },
    selectedClientNumbers: {
        col: "clientNumber",
        key: "clientNumberVal",
        urlKey: urlKeyDict.clientNumFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: []
    },
    selectedEffectiveDates: {
        col: "calculatedEffectiveDate",
        key: "calculatedEffectiveDate",
        urlKey: urlKeyDict.clientEDateFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
    },
    selectedRenewalDates: {
        col: "calculatedRenewalDate",
        key: "calculatedRenewalDate",
        urlKey: urlKeyDict.clientRDateFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
    },
    selectedUsers: {
        col: "accountManagerFullName",
        key: "accountManagerFullNameVal",
        urlKey: urlKeyDict.clientUserFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: []
    },
    selectedServiceRepresentatives: {
        col: "serviceRepresentativeFullName",
        key: "serviceRepresentativeFullNameVal",
        urlKey: urlKeyDict.serviceRepresentativeFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: []
    },
    selectedStatus: {
        col: "clientStatusType",
        key: "clientStatusTypeVal",
        urlKey: urlKeyDict.clientStatusFilter,
        items: [],
        modelName: "clients",
        apiFilters: [],
        filterList: [],
        enumRef: clientStatusTypes,
    },
    clientCheckbox: {
        localStorageKey: localStorageKeyDict.clientCheckboxFilter,
        urlKey: urlKeyDict.clientCheckbox,
        value: false,
    },
    isArchivedCheckbox: {
        localStorageKey: localStorageKeyDict.clientArchiveFilter,
        urlKey: urlKeyDict.clientArchiveFilter,
        value: false,
    },
};

class ClientsDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            fetchingCheckboxFilter: false,
            filtersFetched: false,
            clientsName: [],
            clientsNumber: [],
            clientsServiceRepresentative: [],
            clientsAccountManager: [],
            submitData: true,
            items: [],
            offset: 0,
            q: "",
            filterListsApplied: false,
            limit: 50,
            totalRows: 0,
            modelName: "clients",
            filters: [],
            sortBy: ["clients.name:asc"],
            datatableName: "clients",
            toastMsg: false,
            toastType: null,
            showModal: false,
            errorsString: "",
            actionType: "",
            errorPath: "validation/clientFieldValidation/serverErrors",
            msgTitle: "",
            automaticIdentifierConfigurationTypes: [],
            filtrableCols: JSON.parse(
                JSON.stringify(filtrableColsInitState)
            ) /** Deep copy is needed to not modify the initstate object. */,
        };
        this.archiveClient = this.archiveClient.bind(this);
        this.createClient = this.createClient.bind(this);
        this.createEmptyClientModel = this.createEmptyClientModel.bind(this);
        this.loadFiltersAndSortBy = this.loadFiltersAndSortBy.bind(this);
        this.getData = _.debounce(this.getData.bind(this), 350);
        this.generateCustomItemOptions = this.generateCustomItemOptions.bind(this);
        this.generateAddButton = this.generateAddButton.bind(this);
        this.generateActionButtons = this.generateActionButtons.bind(this);
        this.applyFrontFilterLists = this.applyFrontFilterLists.bind(this);
        this.setCellClassNames = this.setCellClassNames.bind(this);
        this.toggleArchivedClients = this.toggleArchivedClients.bind(this);
        this.updateClient = this.updateClient.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.optionsActions = this.optionsActions.bind(this);
        this.deactivateCheckboxes = this.deactivateCheckboxes.bind(this);
        this.archiveButtonEdit = this.archiveButtonEdit.bind(this);
        this.buildDescription = this.buildDescription.bind(this);
        this.resetFiltersState = this.resetFiltersState.bind(this);
        this.updateDataTable = this.updateDataTable.bind(this);
        this.handleServerError = this.handleServerError.bind(this);
        this.findNestedState = this.findNestedState.bind(this);
        this.handleSuccessMessage = this.handleSuccessMessage.bind(this);
        this.showSingleModalError = this.showSingleModalError.bind(this);
        this.close = this.close.bind(this);
        this.canViewClientModal = this.canViewClientModal.bind(this);
        this.canSubmit = this.canSubmit.bind(this);
        this.toggleClassificationClients = this.toggleClassificationClients.bind(this);
        this.handleCheckboxFilters = this.handleCheckboxFilters.bind(this);
        this.getCheckboxFilters = this.getCheckboxFilters.bind(this);
        this.setAsyncSearchFilter = this.setAsyncSearchFilter.bind(this);
        this.fetchFilters = this.fetchFilters.bind(this);
        this.refetchFilters = this.refetchFilters.bind(this);

        this.canAddImplementation = userHasAccess(DIRECTOR);
        this.canEditImplementation = userHasAccess(FINANCE);
        this.canEditActive = userHasAccess([DIRECTOR, FINTECH, ADMINISTRATOR, FINANCE, MANAGER], true);
        this.canEditInactive = userHasAccess(DIRECTOR);
        this.canEditTerminated = userHasAccess(FINTECH);

        this.canViewClientForImplementation = userHasAccess(MANAGER);
        this.canViewClientForActive = userHasAccess(
            [...HIGH_MANAGEMENT_WITH_FINANCE, MANAGER, PLAN_ADMINISTRATOR],
            true
        );
        this.canViewClientForInactive = userHasAccess(MANAGER);
        this.canViewForTerminated = userHasAccess(MANAGER);
    }

    componentWillMount() {
        try {
            this.deactivateCheckboxes();
            this.props.dataActions.clearDataList(CLIENTS_TABLE_GRAPHQL);
            this.loadFiltersAndSortBy();
            userHasAccess(INTERNAL_ROLES) &&
                this.props.dataActions.getDataItem(CLIENT_CONFIGURATION, "").then((response) => {
                    this.setState({
                        automaticIdentifierConfigurationTypes: response.payload.data.clients.memberIdentifier,
                    });
                });
        } catch (e) {
            this.setState({ isFilterError: true }, () => {
                toast(<FormattedMessage id="pleaseResetFilters" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!this.state.filtersFetched) {
            this.setState({ filtersFetched: true }, () => {
                this.refetchFilters(nextProps);
            });
        }
    }


    componentDidUpdate() {
        if (this.props.sortBy !== this.state.sortBy) {
            this.setState({ sortBy: this.props.sortBy });
        }
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(CLIENTS_TABLE_GRAPHQL);
    }

    refetchFilters(nextProps = null) {
        this.fetchFilters().then(() => {
            this.applyFrontFilterLists(nextProps, true);
        });
    }

    fetchFilters() {
        return this.props.dataActions
            .getDataList(CLIENTS_V2, 0, 0, "", [], [])
            .then((data) => {
                const clients = data.payload.data.items || [];

                const clientsName = Array.from(
                    new Set(clients.map((client) => client.name || "").filter(Boolean))
                ).sort((a, b) => a.localeCompare(b));

                const clientsAccountManager = Array.from(
                    new Set(
                        clients
                            .map((client) =>
                                client.accountManager
                                    ? `${client.accountManager.firstName} ${client.accountManager.lastName}`
                                    : ""
                            )
                            .filter(Boolean)
                    )
                ).sort((a, b) => a.localeCompare(b));

                const clientsServiceRepresentative = Array.from(
                    new Set(
                        clients
                            .map((client) =>
                                client.serviceRepresentative
                                    ? `${client.serviceRepresentative.firstName} ${client.serviceRepresentative.lastName}`
                                    : ""
                            )
                            .filter(Boolean)
                    )
                ).sort((a, b) => a.localeCompare(b));

                const clientsNumber = Array.from(
                    new Set(clients.map((client) => client.clientNumber || "").filter(Boolean))
                ).sort((a, b) => a - b);

                this.setState({
                    clientsName,
                    clientsAccountManager,
                    clientsServiceRepresentative,
                    clientsNumber,
                });
            })
            .catch((error) => {
                throw error;
            });
    }

    getGraphQLQuery(filter, sortBy, offset, limit, queryName, q) {
        const colsStr = `
        name
        clientBillingPeriodType
        extraData
        clientNumber
        clientId
        clientStatusType
        isArchived
        calculatedEffectiveDate
        calculatedRenewalDate
        clientHistory {
            clientHistoryId
        }
        coveragePeriod {
            coveragePeriodId
        }
        clientClassification {
          clientType
        }
        accountManager {
          fullName
        }
        serviceRepresentative {
          fullName
        }
        bloc {
          name
          blocId
        }
      `;
        return buildGraphQLQueryParams("clientsTable", filter, sortBy, offset, limit, colsStr, queryName, q);
    }

    generateCustomItemOptions() {
        const customItemOptions = {
            generateComponent: this.generateActionButtons,
            widthPct: 6.99,
        };

        return customItemOptions;
    }

    close() {
        this.setState({ showModal: false, errorsString: "", actionType: "" });
    }

    deactivateCheckboxes() {
        this.setState({ fetchingCheckboxFilter: true });
    }

    getCheckboxFilters() {
        const checkboxURLParamKeys = ["clientCheckboxFilter", "clientArchiveFilter"];

        checkboxURLParamKeys.forEach((key) => {
            const urlParam = this.getUrlParam(urlKeyDict[key]);
            if (urlParam) {
                localStorage.setItem(localStorageKeyDict[key], urlParam);
            }
        });

        const localStorageFilters = checkboxURLParamKeys
            .map((key) => {
                const localStorageValue = localStorage.getItem(localStorageKeyDict[key]);
                if (!localStorageValue || localStorageValue == "false") {
                    if (key === "clientArchiveFilter") {
                        return CLIENTS.archiveFilter;
                    }
                    return;
                }
                if (key === "clientCheckboxFilter") {
                    return CLIENTS.classificationFilter;
                }
            })
            .filter((filter) => filter);

        return localStorageFilters;
    }

    handleCheckboxFilters(key, value) {
        updateCurrentURL(urlKeyDict[key], value);
        localStorage.setItem(localStorageKeyDict[key], value);
    }

    mapPropsToStates() {
        this.setState({
            items: this.props.items,
            offset: this.props.offset,
            limit: this.props.limit,
            q: this.props.q,
            filters: this.props.filters,
            sortBy: this.props.sortBy,
            totalRows: this.props.total,
        });
    }

    handleSuccessMessage(clientName) {
        toast(
            <FormattedMessage
                id="validation.clientFieldValidation.generalSuccessMessage"
                values={{ client: clientName }}
            />,
            {
                type: toast.TYPE.SUCCESS,
                autoClose: 5000,
            }
        );
    }

    findNestedState(state, nestedKey, byColKey = undefined) {
        for (const stateName in state["filtrableCols"]) {
            if (
                state["filtrableCols"][stateName] &&
                state["filtrableCols"][stateName][byColKey ? "col" : "key"] == nestedKey
            ) {
                return stateName;
            }
        }
        return null;
    }

    createFilterLists(key) {
        const state = store.getState();
        const { formatMessage } = this.context.intl;
        const userLanguage = localStorage.getItem("languageCode") || EN.value;
        const translationFile = userLanguage === EN.value ? enCA : frCA;

        const dataState = state.data.clientsTable.items || [];

        let values = new Set();
        let filterList = [];

        dataState.forEach((data) => {
            switch (key) {
                case "clientTypeName":
                    clientTypes.forEach((type) => {
                        values.add(formatMessage({ id: `clients.${type.key}` }));
                    });
                    values.add(""); // for null case
                    break;

                case "blocName":
                    if (data.bloc) {
                        values.add(data.bloc ? data.bloc.name : "");
                    }
                    break;

                case "accountManagerFullName":
                    if (data.accountManager) {
                        values.add(data.accountManager ? `${data.accountManager.fullName}` : "");
                    }
                    break;

                case "serviceRepresentativeFullName":
                    if (data.serviceRepresentative) {
                        values.add(data.serviceRepresentative ? `${data.serviceRepresentative.fullName}` : "");
                    }
                    break;

                case "calculatedEffectiveDate":
                    if (data.calculatedEffectiveDate) {
                        values.add(data.calculatedEffectiveDate);
                    }
                    break;

                case "calculatedRenewalDate":
                    if (data.calculatedRenewalDate) {
                        values.add(data.calculatedRenewalDate);
                    }
                    break;

                case "clientStatusType":
                    if (data.clientStatusType) {
                        const clientStatus = clientStatusTypes.find((cs) => cs.value === data.clientStatusType);
                        let translatedLabel = "";
                        if (clientStatus && clientStatus.key) {
                            translatedLabel = clientStatus.key.split(".").reduce((acc, key) => {
                                return acc && acc[key] ? acc[key] : "";
                            }, translationFile);
                        }
                        values.add(translatedLabel);
                    }
                    break;

                case "name":
                    if (data.name) {
                        values.add(data.name);
                    }
                    break;
                case "clientNumber":
                    if (data.clientNumber) {
                        values.add(data.clientNumber);
                    }
                    break;
            }
        });

        if (values.size > 0) {
            filterList = Array.from(values).map((value) => ({ [key]: value }));
        }

        const stateName = this.findNestedState(this.state, key);
        this.setState((prevState) => ({
            filtrableCols: {
                ...prevState.filtrableCols,
                [stateName]: {
                    ...prevState.filtrableCols[stateName],
                    filterList: filterList,
                },
            },
        }));
    }

    setAsyncSearchFilter(colKey, filterToApply) {
        let nestedStateName = null;
        let currentAPIFilters = null;

        let allAPIFiltersForCol = [];

        if (["clientTypeName", "clientStatusType", "name", "serviceRepresentativeFullName", "accountManagerFullName", "clientNumber"].includes(colKey)) {
            nestedStateName = this.findNestedState(this.state, colKey, true);
        } else {
            nestedStateName = this.findNestedState(this.state, colKey);
            currentAPIFilters = this.state.filtrableCols[nestedStateName].apiFilters;
        }

        /**
         * We want to remove any previous like filter in the state.
         */

        if (currentAPIFilters) {
            let existingLikeFilterIndex = -1;

            currentAPIFilters.forEach((filter, i) => {
                if (filter.includes("=like=")) {
                    existingLikeFilterIndex = i;
                }
            });

            if (existingLikeFilterIndex > -1) {
                currentAPIFilters.splice(existingLikeFilterIndex, 1);
            }

            allAPIFiltersForCol = allAPIFiltersForCol.concat(currentAPIFilters);
        }

        filterToApply && allAPIFiltersForCol.push(filterToApply);

        this.setState((prevState) => ({
            filtrableCols: {
                ...prevState.filtrableCols,
                [nestedStateName]: {
                    ...prevState["filtrableCols"][nestedStateName],
                    apiFilters: allAPIFiltersForCol,
                },
            },
        }));
    }

    getUrlParam(param) {
        const url = new URL(window.location.href);
        const search_params = url.searchParams;
        return search_params.get(param);
    }

    getKeysFromLocalStorage(selectedState) {
        const keys = localStorage.getItem(selectedState.localStorageKey);
        return keys ? keys.split(",") : [];
    }

    archiveClient(clientId, isArchived) {
        this.props.dataActions.updateDataItem(CLIENTS, { clientId, isArchived: !isArchived }).then(() => {
            this.updateDataTable();
        });
    }

    archiveButtonEdit(allowSubmission) {
        this.setState({ submitData: !allowSubmission });
    }

    cleanClientValues(model) {
        const majorFixedFee = model.majorFixedFee || 0;
        const majorVariableFee = model.majorVariableFee || 0;
        const filteredBrokers = model.broker && model.broker.filter((item) => item.brokerId !== null);
        const broker = filteredBrokers ? filteredBrokers : model.broker;
        const provinceCode = model.provinceCode === "noProvinces" ? null : model.provinceCode;
        const acombaNumber = !model.acombaNumber || ("" + model.acombaNumber).trim() === "" ? null : model.acombaNumber;
        const acombaProjectNumber =
            !model.acombaProjectNumber || model.acombaProjectNumber.trim() === "" ? null : model.acombaProjectNumber;
        const blocId = !model.blocId || ("" + model.blocId).trim() === "" ? null : model.blocId;
        const localizations = {};
        [...this.props.languages].map((l) => {
            localizations[l.languageCode] = {
                withdrawalFormMessage: null,
                languageCode: l.languageCode,
            };
        });

        return {
            ...model,
            acombaNumber,
            acombaProjectNumber,
            blocId,
            majorFixedFee,
            majorVariableFee,
            provinceCode,
            localizations,
            broker,
        };
    }

    handleServerError(serverMessage, actionType, userLanguage, customMessage = undefined) {
        let errorCodesToString = getParsedErrors(serverMessage, userLanguage, this.state.errorPath);
        this.setState({
            showModal: true,
            errorsString: errorCodesToString,
            actionType: actionType,
            msgTitle: customMessage ? customMessage : "validation.clientFieldValidation.generalErrorMessage",
        });
    }

    showSingleModalError(errorCode, userLanguage, actionType) {
        let serverMessage = getSingleErrorFromCode(errorCode, userLanguage, this.state.errorPath);
        this.setState({
            showModal: true,
            errorsString: serverMessage,
            actionType: actionType,
        });
    }

    createClient(values) {
        this.deactivateCheckboxes();
        let newValues = this.cleanClientValues(values);
        const selectInputValue = newValues["isAutomaticMemberIdentifier"];
        newValues["isAutomaticMemberIdentifier"] = selectInputValue ? selectInputValue === AUTOMATIC.value : false;
        const isGmRecurring =
            newValues["businessAccountType"] == GM.value && newValues["clientBillingPeriodType"] == RECURRING.value;
        const isPmManual =
            newValues["businessAccountType"] == PM.value &&
            newValues["clientBillingPeriodType"] == MANUAL_BILLING_PERIOD.value;
        if (selectInputValue === undefined && (isGmRecurring || isPmManual)) {
            newValues["isAutomaticMemberIdentifier"] = null;
        }
        return this.props.dataActions.createDataItem(CLIENTS, newValues).then((data) => {
            if (data.type === types.CREATE_DATA_ITEM_FAILURE) {
                // Ready to send multiple errors back to the form if/when the backend returns multiple errors at a time
                let serverValidationErrors = {};
                if (data.payload.error.data.error === "missing_fields_error") {
                    const serverMessage = data.payload.error.data.message.split(":")[1].trim();
                    const userLanguage = localStorage.getItem("languageCode") || EN.value;

                    const translationFile = userLanguage == EN.value ? enCA : frCA;

                    if (serverMessage.includes("client_number_mandatory_error")) {
                        /**
                         * Error for empty client number, when trying to set member identifier.
                         */
                        serverValidationErrors.clientNumber = {
                            messageKey: "validation.clientFieldValidation.clientNumberWarnForIdentifier",
                            values: {},
                            state: "error",
                        };
                    }

                    this.handleServerError(
                        serverMessage,
                        translationFile.validation.clientFieldValidation.creationAction,
                        userLanguage
                    );
                }
                if (data.payload.error.data.error === "duplicateDesignator") {
                    serverValidationErrors.designator = {
                        messageKey: "validation.customMessages.serverErrors.duplicateDesignator",
                        values: {},
                        state: "error",
                    };
                }
                if (data.payload.error.data.error === "existing_client_bad_member_configuration") {
                    serverValidationErrors.clientNumber = {
                        messageKey: "validation.customMessages.serverErrors.existingClientConfigurationError",
                        values: {},
                        state: "error",
                    };
                }
                if (data.payload.error.data.error === "duplicateClientName") {
                    serverValidationErrors.name = {
                        messageKey: "validation.customMessages.serverErrors.duplicateClientName",
                        values: {},
                        state: "error",
                    };
                }
                if (data.payload.error.data.error === "client_number_mandatory_error") {
                    serverValidationErrors.clientNumber = {
                        messageKey: "validation.clientFieldValidation.serverErrors.clientNumberMandatory",
                        values: {},
                        state: "error",
                    };
                }
                if (data.payload.error.data.error === "dateRequired") {
                    serverValidationErrors.coveragePeriod = {
                        startDate: {
                            messageKey: "validation.customMessages.serverErrors.dateRequired",
                            values: {},
                            state: "error",
                        },
                        endDate: {
                            messageKey: "validation.customMessages.serverErrors.dateRequired",
                            values: {},
                            state: "error",
                        },
                    };
                }
                if (data.payload.error.data.error === "accountTypeRequired") {
                    serverValidationErrors.businessAccountType = {
                        messageKey: "validation.customMessages.serverErrors.accountTypeRequired",
                        values: {},
                        state: "error",
                    };
                }
                if (data.payload.error.data.error === "noSymbolsInClientNumber") {
                    serverValidationErrors.clientNumber = {
                        messageKey: "validation.customMessages.serverErrors.noSymbolsInClientNumber",
                        values: {},
                        state: "error",
                    };
                }

                if (data.payload.error.data.error === "manualMemberIdentifierType") {
                    serverValidationErrors.clientNumber = {
                        messageKey: "validation.customMessages.serverErrors.manualMemberIdentifierType",
                        values: {},
                        state: "error",
                    };
                }
                if (serverValidationErrors) {
                    throw new SubmissionError(serverValidationErrors);
                }
            } else {
                this.handleSuccessMessage(newValues.name);
                this.setState({ offset: 0 });
                this.refetchFilters();
                this.updateDataTable();
            }
        });
    }

    updateDataTable() {
        this.getData(this.state.offset, this.state.limit, this.props.q, this.state.sortBy, this.state.filters, true);
    }

    createEmptyClientModel() {
        const accountBusinessUnits = [];
        const businessAccountType =
            accountBusinessUnits.length == 1 ? accountBusinessUnits[0].accountBusinessUnitId : null;
        return {
            ratePeriodType: ratePeriodTypes[0].value,
            clientBillingPeriodType: null,
            clientInsuranceStatusType: insuranceStatuses[0].value,
            coverageWebsite: "",
            name: "",
            fullName: "",
            address: "",
            countryCode: "CA",
            provinceCode: "",
            postalCode: "",
            majorFixedFee: 0,
            majorVariableFee: 0,
            syncType: null,
            businessAccountType: businessAccountType,
            ungroupGuaranteesInInvoices: false,
            shouldImportWithoutId: false,
            isPublishable: true,
            showDependentPersonFormula: false,
            coveragePeriod: { startDate: "", endDate: "" },
        };
    }

    setCellClassNames(client) {
        return classNames({
            archived: client.isArchived,
            "client-datatable-value": true,
        });
    }

    toggleArchivedClients() {
        this.deactivateCheckboxes();
        const isArchivedFiltered = this.state.filters.includes(CLIENTS.archiveFilter);
        const filters = isArchivedFiltered
            ? this.state.filters.filter((filter) => filter != CLIENTS.archiveFilter)
            : [...this.state.filters, CLIENTS.archiveFilter];
        this.handleCheckboxFilters("clientArchiveFilter", isArchivedFiltered);
        this.setState({ offset: 0 });
        this.getData(0, this.state.limit, this.props.q, this.state.sortBy, filters, true);
    }

    toggleClassificationClients() {
        this.deactivateCheckboxes();
        const isClassificationFiltered = this.state.filters.includes(CLIENTS.classificationFilter);
        const filters = isClassificationFiltered
            ? this.state.filters.filter((filter) => filter != CLIENTS.classificationFilter)
            : [...this.state.filters, CLIENTS.classificationFilter];
        this.handleCheckboxFilters("clientCheckboxFilter", !isClassificationFiltered);
        this.setState({ offset: 0 });
        this.getData(0, this.state.limit, this.props.q, this.state.sortBy, filters, true);
    }

    updateClient(values) {
        /**
         * Function that will update a client (from the client modal).
         */
        const { dataActions } = this.props;
        this.deactivateCheckboxes();
        const clean = pipe(this.cleanClientValues.bind(this), cleanBrokerRelationshipsFromForm);
        const userLanguage = localStorage.getItem("languageCode") || EN.value;
        const translationFile = userLanguage == EN.value ? enCA : frCA;
        return updateClientAndValidate(
            dataActions,
            clean(values),
            this.updateDataTable,
            this.handleServerError,
            translationFile.validation.clientFieldValidation.modifyAction,
            this.showSingleModalError,
            userLanguage
        );
    }

    onFilterChange(selectedValues, colKey, newFilters = undefined, sortBy = undefined) {
        const nestedStateName = this.findNestedState(this.state, colKey);
        if (!sortBy) {
            let filtersToApply = newFilters ? newFilters.split(";").filter(Boolean) : ""; // Boolean only keeps truthy values.
            this.setState((prevState) => ({
                filtrableCols: {
                    ...prevState.filtrableCols,
                    [nestedStateName]: {
                        ...prevState["filtrableCols"][nestedStateName],
                        items: selectedValues,
                        apiFilters: filtersToApply,
                    },
                },
                fetchingCheckboxFilter: true,
            }));
            return filtersToApply;
        }
    }

    loadFiltersAndSortBy() {
        let colNames = [];
        let allLocalStorageFilters = new Set();
        let sortByValue = "";
        const { formatMessage } = this.context.intl;

        for (const key of Object.keys(this.state.filtrableCols)) {
            if (key != "clientCheckbox" && key != "isArchivedCheckbox") {
                colNames.push(this.state.filtrableCols[key]["col"]);
            }
        }

        colNames.forEach((col) => {
            const localStorageKey = this.state.datatableName + "." + col;
            const localStorage = getLocalStorageFilter(localStorageKey);

            let allColFilters = [];
            const queryParams = getQueryParams(col);

            queryParams &&
                queryParams.forEach((param) => {
                    const isLikeFilter = param.includes("like=");
                    if (isLikeFilter) {
                        param = param.split("like=")[1];
                    }
                    const formattedFilter = this.state.modelName + "." + col + LIKE + param;
                    allColFilters.push(formattedFilter);
                    allLocalStorageFilters.add(formattedFilter);
                });

            if (allColFilters.length > 0) {
                /**
                 * If query params are present, we want to override the localstorage filters.
                 */
                const localStorageVal = allColFilters.join(";");
                setLocalStorageFilters(localStorageKey, localStorageVal);
            }

            if (localStorage && !queryParams) {
                const filters = localStorage.split(";"); // One localstorage can have multiple filters.
                filters.forEach((filter) => {
                    allLocalStorageFilters.add(filter);
                });
            }
        });

        allLocalStorageFilters = Array.from(allLocalStorageFilters).filter((filter) => filter);
        let filtrableCols = { ...this.state.filtrableCols };
        allLocalStorageFilters.forEach((filter) => {
            const filterEqualsArr = filter.split(EQUALS);
            const filterLikeArr = filter.split(LIKE);

            const filterArr = filterEqualsArr.length > 1 ? filterEqualsArr : filterLikeArr;
            const filterKey = filterArr[0].split(".")[1];

            const nestedStateName = this.findNestedState(this.state, filterKey, true);
            /**
             * We have to treat enum cols seperately. Since they have 2 values in their objects:
             * Label name and value for db, we need to loop over the enum file array.
             */

            filtrableCols[nestedStateName]["apiFilters"].push(filter);
            if (filtrableCols[nestedStateName]["enumRef"]) {
                const formattedMessageEnum = filtrableCols[nestedStateName]["enumRef"].filter(
                    (filter) => filter.value === filterArr[1]
                );

                filtrableCols[nestedStateName]["items"].push({
                    [filterKey]:
                        formattedMessageEnum.length > 0
                            ? formatMessage({
                                id:
                                    nestedStateName == "selectedClientTypes"
                                        ? "clients." + formattedMessageEnum[0].key
                                        : formattedMessageEnum[0].key,
                            })
                            : filterArr[1],
                    [filterKey + "Val"]: filterArr[1],
                });
            } else {
                filtrableCols[nestedStateName]["items"].push({
                    [filterKey]: filterArr[1],
                });
            }
        });

        const sort = getUrlParam("sort");

        if (sort) {
            setLocalStorageFilters(this.state.datatableName + "." + "sortBy", sort);
        }

        sortByValue = getLocalStorageFilter(this.state.datatableName + "." + "sortBy");

        const checkboxFilters = this.getCheckboxFilters();
        this.setState({
            filters: [...checkboxFilters, ...allLocalStorageFilters],
            filtrableCols: filtrableCols,
            sortBy: [sortByValue ? sortByValue : "clients.name:asc"],
        });
        return [allLocalStorageFilters, sortByValue];
    }

    getCols() {
        const today = new Date();
        const date90d = new Date();
        date90d.setDate(date90d.getDate() + 90);
        const statusValueClassName = "value-status";
        const warningValueClassName = "value-warning";
        const criticalValueClassName = "value-critical";
        const emptyValueClassName = "value-empty";

        const {
            filtrableCols: {
                selectedClientTypes,
                selectedBlocs,
                selectedClients,
                selectedClientNumbers,
                selectedEffectiveDates,
                selectedRenewalDates,
                selectedUsers,
                selectedServiceRepresentatives,
                selectedStatus,
            },
        } = this.state;

        const { formatMessage } = this.context.intl;
        const onHeaderFilterChange = this.onFilterChange;
        const setCellClassNames = this.setCellClassNames;

        const clientTypeCol = new Col(
            <FormattedMessage id="clients.form.client.clientType" />,
            (data) => {
                if (data && data.clientClassification && data.clientClassification.clientType != null) {
                    return (
                        <span className={setCellClassNames(data)}>
                            {formatMessage({
                                id: "clients.clientTypes." + data.clientClassification.clientType.toLowerCase(),
                            })}
                        </span>
                    );
                }
                return null;
            },
            9,
            "clients.client_type_name",
            true,
            selectedClientTypes,
            "clients.form.client.clientType",
            onHeaderFilterChange,
            false,
            false
        );

        const blocCol = new Col(
            <FormattedMessage id="clients.form.client.bloc" />,
            (data) => {
                return <span className={setCellClassNames(data)}>{data.bloc ? data.bloc.name : ""}</span>;
            },
            11,
            "clients.bloc_name",
            true,
            selectedBlocs,
            "clients.form.client.bloc",
            onHeaderFilterChange,
            false,
            true
        );

        const nameCol = new Col(
            <FormattedMessage id="clients.datatable.columns.client" />,
            (data) => {
                const link = `dashboard/clients/${data.clientId}`;
                const nameSpan = <span className={setCellClassNames(data)}>{data.name}</span>;
                return data.extraData.isVip ? (
                    <Link className="border-width" to={link} title={data.name}>
                        <div className="name-border-for-dt">{nameSpan}</div>
                    </Link>
                ) : (
                    <Link to={link} title={data.name}>
                        {nameSpan}
                    </Link>
                );
            },
            18,
            "clients.name",
            true,
            selectedClients,
            "clients.datatable.columns.client",
            onHeaderFilterChange,
            false,
            true
        );

        const clientNumberCol = new Col(
            <FormattedMessage id="clients.form.otherInformation.shortClientNumber" />,
            (data) => <span className={setCellClassNames(data)}>{data.clientNumber}</span>,
            8,
            "clients.client_number",
            true,
            selectedClientNumbers,
            "clients.form.otherInformation.shortClientNumber",
            onHeaderFilterChange,
            false,
            true
        );

        const effectiveDateCol = new Col(
            <FormattedMessage id="clients.form.otherInformation.effectiveDate" />,
            (data) => {
                const isInvalidDate = !data.calculatedEffectiveDate || new Date(data.calculatedEffectiveDate).getFullYear() === 1970;
                const className = `${setCellClassNames(data)}${isInvalidDate ? ` ${statusValueClassName} ${emptyValueClassName} ${criticalValueClassName}` : ""
                    }`;
                return (
                    <span className={className}>
                        {data.calculatedEffectiveDate && (
                            <FormattedDate
                                value={data.calculatedEffectiveDate}
                                year="numeric"
                                month="long"
                                day="2-digit"
                                timeZone="UTC"
                            />
                        )}
                    </span>
                );
            },
            8.99,
            "clients.calculated_effective_date",
            true,
            selectedEffectiveDates,
            "clients.form.otherInformation.effectiveDate",
            onHeaderFilterChange,
            true,
            true
        );

        const renewalDateCol = new Col(
            <FormattedMessage id="clients.form.otherInformation.terminationDate" />,
            (data) => {
                const tmpDate = new Date(data.calculatedRenewalDate);
                const isInvalidDate = !data.calculatedRenewalDate || tmpDate.getFullYear() === 1970;
                const isCritical = tmpDate < today;
                const isWarning = tmpDate < date90d;
                let className = `${setCellClassNames(data)}`;
                if (isInvalidDate) {
                    className += ` ${statusValueClassName} ${emptyValueClassName} ${criticalValueClassName}`;
                } else if (isCritical) {
                    className += ` ${statusValueClassName} ${criticalValueClassName}`;
                } else if (isWarning) {
                    className += ` ${statusValueClassName} ${warningValueClassName}`;
                }
                return (
                    <span className={className}>
                        {data.calculatedRenewalDate && (
                            <FormattedDate
                                value={data.calculatedRenewalDate}
                                year="numeric"
                                month="long"
                                day="2-digit"
                                timeZone="UTC"
                            />
                        )}
                    </span>
                );
            },
            11,
            "clients.calculated_renewal_date",
            true,
            selectedRenewalDates,
            "clients.form.otherInformation.terminationDate",
            onHeaderFilterChange,
            true,
            true
        );

        const accountManagerCol = new Col(
            <FormattedMessage id="clients.form.otherInformation.shortAccountManager" />,
            (data) => {
                const className = `${setCellClassNames(data)}${!data.accountManager
                    ? ` ${statusValueClassName} ${emptyValueClassName} ${criticalValueClassName}`
                    : ""
                    }`;
                return (
                    <span className={className}>{data.accountManager ? `${data.accountManager.fullName}` : ""}</span>
                );
            },
            9,
            "clients.account_manager_full_name",
            true,
            selectedUsers,
            "clients.form.otherInformation.shortAccountManager",
            onHeaderFilterChange,
            false,
            true
        );

        const serviceRepCol = new Col(
            <FormattedMessage id="clients.form.otherInformation.shortServiceRepresentative" />,
            (data) => {
                const className = `${setCellClassNames(data)}${!data.serviceRepresentative
                    ? ` ${statusValueClassName} ${emptyValueClassName} ${criticalValueClassName}`
                    : ""
                    }`;
                return (
                    <span className={className}>
                        {data.serviceRepresentative ? `${data.serviceRepresentative.fullName}` : ""}
                    </span>
                );
            },
            9,
            "clients.service_representative_full_name",
            true,
            selectedServiceRepresentatives,
            "clients.form.otherInformation.shortServiceRepresentative",
            onHeaderFilterChange,
            false,
            true
        );

        const statusCol = new Col(
            <FormattedMessage id="clients.datatable.columns.status" />,
            (data) => {
                const statusObj = clientStatusTypes.find((s) => s.value === data.clientStatusType);
                const statusKey = statusObj ? statusObj.key : null;
                const className = `${setCellClassNames(
                    data
                )} status-indicator status-${data.clientStatusType.toLowerCase().replace(/_/g, "-")}`;
                return <div className={className}>{statusKey && <FormattedMessage id={statusKey} />}</div>;
            },
            9,
            "clients.client_status_type",
            true,
            selectedStatus,
            "clients.datatable.columns.status",
            onHeaderFilterChange,
            false,
            false
        );

        return [
            clientTypeCol,
            blocCol,
            nameCol,
            clientNumberCol,
            effectiveDateCol,
            renewalDateCol,
            accountManagerCol,
            serviceRepCol,
            statusCol,
        ];
    }
    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }

    buildDescription(clientName) {
        const userLanguage = localStorage.getItem("languageCode") || EN.value;

        if (userLanguage == FR.value) {
            return frCA.downloader.clientMajorCardExport + ": " + clientName;
        }

        return enCA.downloader.clientMajorCardExport + ": " + clientName;
    }

    canViewClientModal(client) {
        switch (client.clientStatusType) {
            case IMPLEMENTATION.value:
                return this.canViewClientForImplementation;
            case ACTIVE.value:
                return this.canViewClientForActive;
            case INACTIVE.value:
                return this.canViewClientForInactive;
            case TERMINATED.value:
                return this.canViewForTerminated;
        }
    }

    canSubmit(client) {
        switch (client.clientStatusType) {
            case IMPLEMENTATION.value:
                return this.canEditImplementation;
            case ACTIVE.value:
                return this.canEditActive;
            case INACTIVE.value:
                return this.canEditInactive;
            case TERMINATED.value:
                return this.canEditTerminated;
        }
    }

    optionsActions(client) {
        const { blocs } = this.props;
        const canArchiveClient = userHasAccess(DIRECTOR);

        const canSubmit = this.canSubmit(client);
        const options = [
            {
                component: (
                    <EditButton
                        modalClassName="extra-large-modal"
                        confirmationTitle={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                {this.renderFormatedMessage}
                            </FormattedMessage>
                        }
                        confirmationMessage={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                        }
                        closeButtonKey="common.cancel"
                        requiresCloseConfirmation={true}
                        confirmOnClose={true}
                        title={
                            canSubmit ? (
                                <FormattedMessage id="clients.datatable.actions.edit" />
                            ) : (
                                <FormattedMessage id="clients.datatable.actions.view" />
                            )
                        }
                        form={BasicClientsFields}
                        allowSubmission={this.state.submitData && canSubmit}
                        props={{
                            blocs,
                            archiveButton: this.archiveButtonEdit,
                            create: false,
                            clientId: client.clientId,
                            clientName: client.name,
                            updateDataTable: this.updateDataTable,
                            isClientsDataTable: true,
                            automaticIdentifierConfigurationTypes: this.state.automaticIdentifierConfigurationTypes,
                        }}
                        getData={this.props.dataActions.getDataItem.bind(this, CLIENTS, client.clientId)}
                        editFunction={this.updateClient}
                    />
                ),
                icon: canSubmit ? <span className="icon icon-compose" /> : <span className="icon icon-eye" />,
                label: canSubmit ? "common.edit" : "common.view",
                requirement: this.canViewClientModal(client),
            },
        ];

        if (canArchiveClient && client.clientStatusType == IMPLEMENTATION.value && !client.isArchived) {
            options.push({
                component: (
                    <ArchiveButton
                        showDefaultDanger={true}
                        isArchived={client.isArchived}
                        archivedName={client.name}
                        archiveFunction={this.archiveClient.bind(null, client.clientId, client.isArchived)}
                    />
                ),
                icon: <span className="icon icon-bin" />,
                label: client.isArchived ? "common.unarchive" : "common.archive",
            });
        }
        if (
            client.clientBillingPeriodType !== MANUAL_BILLING_PERIOD.value &&
            !RESTRICTED_STATUSES.includes(client.clientStatusType)
        ) {
            const description = this.buildDescription(client.name);
            const CUSTOM_CLIENTS_TABLE_GRAPHQL = {
                ...CLIENTS_TABLE_GRAPHQL,
                path: CLIENTS.path,
            };

            options.push({
                component: (
                    <DownloadButton
                        model={CUSTOM_CLIENTS_TABLE_GRAPHQL}
                        path={`${client.clientId}/major-cards-all`}
                        filters={[]}
                        skipModal={true}
                        disabled={!canDownload(description, this.props.currentDownloads)}
                        identifier={description}
                        toastMsg="members.member.actions.generating"
                        closeButton={false}
                        showGeneratingToast={true}
                    />
                ),
                icon: <span className="icon icon-in" />,
                label: "members.member.actions.majorCard",
            });
        }
        return options;
    }

    onOpenMenu(event) {
        const nodes = document.getElementsByClassName("fixedDataTableRowLayout_rowWrapper");
        Array.from(nodes).forEach((n) => (n.style["z-index"] = 0));
        event.target.closest(".fixedDataTableRowLayout_rowWrapper").style["z-index"] = 1;
    }

    generateActionButtons(client) {
        return <OptionsMenu onClick={this.onOpenMenu} options={this.optionsActions(client)} />;
    }

    generateAddButton() {
        const { filters } = this.state;
        const { blocs } = this.props;

        return (
            <div className="flex-box">
                <CheckboxButton
                    className="include-archived"
                    id="showOnly"
                    disabled={this.state.fetchingCheckboxFilter}
                    label={
                        <span>
                            <FormattedMessage id="clients.datatable.actions.showOnly" />
                            <span className="client-word-style">
                                <FormattedMessage id="clients.title" />
                            </span>
                        </span>
                    }
                    checked={filters.includes(CLIENTS.classificationFilter)}
                    onClick={this.toggleClassificationClients}
                />
                {this.canAddImplementation && (
                    <div>
                        <CheckboxButton
                            className="include-archived"
                            id="archived"
                            disabled={this.state.fetchingCheckboxFilter}
                            label={<FormattedMessage id="clients.datatable.actions.includeArchivedClients" />}
                            checked={!filters.includes(CLIENTS.archiveFilter)}
                            onClick={this.toggleArchivedClients}
                        />
                        <EditButton
                            modalClassName="extra-large-modal"
                            confirmationTitle={
                                <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                    {this.renderFormatedMessage}
                                </FormattedMessage>
                            }
                            confirmationMessage={
                                <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                            }
                            closeButtonKey="common.cancel"
                            requiresCloseConfirmation={true}
                            confirmOnClose={true}
                            title={<FormattedMessage id="clients.datatable.actions.add" />}
                            label={<FormattedMessage id="common.add" />}
                            add={true}
                            form={BasicClientsFields}
                            props={{
                                blocs,
                                archiveButton: this.archiveButtonEdit,
                                filters: this.state.filters,
                                create: true,
                                automaticIdentifierConfigurationTypes: this.state.automaticIdentifierConfigurationTypes,
                            }}
                            data={this.createEmptyClientModel()}
                            editFunction={this.createClient}
                        />
                    </div>
                )}
            </div>
        );
    }

    getData(
        offset,
        limit,
        q,
        sortBy,
        filters,
        forceGetData,
        searchedCols,
        searchColKey = undefined,
        isFrontFilter = false,
        clearFilterList = false
    ) {
        searchedCols = searchedCols || [];

        this.setState({ filters: filters });
        if (forceGetData || this.props.dataFetched) {
            let graphQLFilters = "";
            let graphQLSort = "";

            filters = filters.filter((f) => f);
            sortBy = sortBy.filter((s) => s);
            if (filters) {
                graphQLFilters = toGraphQLFormat(filters);
                graphQLFilters = formatMultipleFilters(graphQLFilters);
            }
            if (sortBy) {
                graphQLSort = toGraphQLSortFormat(sortBy);
            }
            const graphQLQuery = this.getGraphQLQuery(graphQLFilters, graphQLSort, offset, limit, "clientsTable", q);

            return this.props.dataActions
                .getGraphQL(CLIENTS_TABLE_GRAPHQL, { query: graphQLQuery }, graphQLSort)
                .then(() => {
                    searchedCols &&
                        searchedCols.map((colKey) => {
                            /**
                             * For every request, we refresh the filter lists of the current active searches. (Determined by DTV2 and SelectHeaderV2).
                             * This is helpful when we change the offset, and want correct results in the filter dropdowns.
                             */
                            this.createFilterLists(colKey);
                        });

                    if (!isFrontFilter && clearFilterList) {
                        this.clearFilterList(searchColKey);
                    }

                    this.setState({ fetchingCheckboxFilter: false });
                });
        }
        return Promise.resolve();
    }

    clearFilterList(colKey) {
        const stateName = this.findNestedState(this.state, colKey);

        this.setState((prevState) => ({
            filtrableCols: {
                ...prevState.filtrableCols,
                [stateName]: {
                    ...prevState["filtrableCols"][stateName],
                    filterList: [],
                },
            },
            fetchingCheckboxFilter: true
        }));
    }

    generateFilters(values, valueKey, modelName, colName) {
        /**
         * Function will reconstruct selected filter values into an
         * API format filter.
         */

        let filterString = "";

        if (values) {
            let selectedFilters = values.map((filter) => filter[valueKey]);

            for (let filter of selectedFilters) {
                filterString += modelName + "." + colName + LIKE + filter + ";";
            }
        }
        return filterString;
    }

    resetFiltersState(resetActiveSearches) {
        Object.keys(localStorageKeyDict).forEach((key) => {
            localStorage.removeItem(localStorageKeyDict[key]);
            updateCurrentURL(urlKeyDict[key], null);
        });

        this.setState(
            {
                filtrableCols: JSON.parse(JSON.stringify(filtrableColsInitState)),
                filters: [CLIENTS_TABLE_GRAPHQL.archiveFilter],
                filterListsApplied: false,
                offset: 0,
                sortBy: ["clients.name:asc"],
            },
            () => this.getData(0, this.state.limit, this.props.q, this.state.sortBy, this.state.filters)
        );
        resetActiveSearches(undefined, undefined, true);
    }

    applyFrontFilterLists(nextProps, forceFilters = false) {
        // eslint-disable-line no-unused-vars
        const { formatMessage } = this.context.intl;
        let filtrableCols = { ...this.state.filtrableCols };
        if (this.state.filterListsApplied && !forceFilters) {
            return;
        }
        const statusLocales = clientStatusTypes.map((status) => {
            return {
                clientStatusType: formatMessage({ id: status.key }),
                clientStatusTypeVal: status.value,
            };
        });

        const clientTypesLocales = clientTypes.map((priority) => {
            return {
                clientTypeName: formatMessage({ id: "clients." + priority.key }),
                clientTypeNameVal: priority.value,
            };
        });

        const clientNameLocales = this.state.clientsName.map((priority) => {
            return {
                name: priority,
                nameVal: priority,
            };
        });

        const accountManagerFullNameLocales = this.state.clientsAccountManager.map((priority) => {
            return {
                accountManagerFullName: priority,
                accountManagerFullNameVal: priority,
            };
        });

        const serviceRepresentativeFullNameLocales = this.state.clientsServiceRepresentative.map((priority) => {
            return {
                serviceRepresentativeFullName: priority,
                serviceRepresentativeFullNameVal: priority,
            };
        });

        const clientNumberLocales = this.state.clientsNumber.map((priority) => {
            return {
                clientNumber: priority,
                clientNumberVal: priority,
            };
        });

        filtrableCols.selectedStatus.filterList = [
            ...this.state.filtrableCols.selectedStatus.filterList,
            ...statusLocales,
        ];
        filtrableCols.selectedClientTypes.filterList = [
            ...this.state.filtrableCols.selectedClientTypes.filterList,
            ...clientTypesLocales,
        ];
        filtrableCols.selectedClients.filterList = [
            ...this.state.filtrableCols.selectedClients.filterList,
            ...clientNameLocales,
        ];
        filtrableCols.selectedServiceRepresentatives.filterList = [
            ...this.state.filtrableCols.selectedServiceRepresentatives.filterList,
            ...serviceRepresentativeFullNameLocales,
        ];
        filtrableCols.selectedUsers.filterList = [
            ...this.state.filtrableCols.selectedUsers.filterList,
            ...accountManagerFullNameLocales,
        ];
        filtrableCols.selectedClientNumbers.filterList = [
            ...this.state.filtrableCols.selectedClientNumbers.filterList,
            ...clientNumberLocales,
        ];

        this.setState({
            filtrableCols,
            filterListsApplied: true
        });
    }

    render() {
        const { limit, offset, total } = this.props;
        const items = this.props.items;
        const pagination = { rowsPerPage: limit, offset };

        return (
            <div>
                <DataTableV2
                    ref="dataTableV2"
                    getData={this.getData}
                    cols={this.getCols()}
                    offset={this.state.offset}
                    filters={this.state.filters}
                    data={items}
                    fetchingCheckboxFilter={this.state.fetchingCheckboxFilter}
                    pagination={pagination}
                    rowsPerPage={this.state.limit}
                    showOverflow={false}
                    totalRows={total}
                    sortBy={this.state.sortBy}
                    customDataTableOptions={this.generateAddButton()}
                    generateFilters={this.generateFilters}
                    refetchFilters={this.refetchFilters}
                    dataTableName={this.state.datatableName}
                    setAsyncFilters={this.setAsyncSearchFilter}
                    tableName="client"
                    isGraphQL={true}
                    showEmptyFiltersBtn={true}
                    resetFiltersState={this.resetFiltersState}
                    customEmptyBtnFilterClass="empty-filters"
                    deactivateCheckboxes={this.deactivateCheckboxes}
                    customItemOptions={this.generateCustomItemOptions()}
                    title="Clients"
                    hideQ={false}
                    refreshFunction={this.getData}
                    cleanQ={true}
                />

                {renderErrorModal(
                    this.state.showModal,
                    this.close,
                    this.state.errorsString,
                    this.state.msgTitle,
                    this.state.actionType
                )}
            </div>
        );
    }
}

ClientsDataTable.propTypes = {
    dataActions: PropTypes.object,
    blocs: PropTypes.object,
    filters: PropTypes.array,
    q: PropTypes.string,
    limit: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    items: PropTypes.array,
    statuses: PropTypes.array,
    insuranceTypes: PropTypes.array,
    languages: PropTypes.array.isRequired,
    toastMsg: PropTypes.string,
    toastType: PropTypes.string,
    currentDownloads: PropTypes.array,
    dataFetched: PropTypes.bool,
};

ClientsDataTable.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state) {
    const data = state.data && state.data.clientsTable ? state.data.clientsTable : {};
    const blocs = state.data.blocs || {};
    const currentDownloads = state.downloader || {};
    return {
        filters: data.filters || [CLIENTS_TABLE_GRAPHQL.archiveFilter],
        limit: data.limit || 50,
        blocs: blocs.items || [],
        q: state.form && state.form.tableQ && state.form.tableQ.values ? state.form.tableQ.values.q : "",
        offset: data.offset || 0,
        sortBy: data.sortBy || [],
        total: data.totalCount || 0,
        items: data.items || null,
        dataFetched: !!data.fetched,
        currentDownloads: currentDownloads.files || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/ClientsDataTable.js